import React from 'react'
import PropTypes from 'prop-types'
import { useIntl } from 'react-intl'
import { Dialog, Typography, withStyles } from '@material-ui/core'

import { CLOSE } from 'app/constants/button'
import OutlinedButtons from 'app/componentV4/Button/OutlinedButtons'

const CustomsSubmitDialog = withStyles({
  root: {
    '& .MuiDialog-paper': {
      width: '375px !important',
      overflowX: 'auto',
      padding: '3rem',
    },
  },
})(Dialog)

const InformationDialog = (props) => {
  const {
    id,
    open = false,
    title,
    onClose,
    children,
    className,
    description,
    closeText = 'action.ok',
  } = props

  const { formatMessage } = useIntl()

  return (
    <CustomsSubmitDialog
      id={id}
      open={open}
      onClose={onClose}
      className={className}
      aria-labelledby={id}
    >
      <Typography className="text-lg font-bold text-center text-primary">
        {title}
      </Typography>
      {description && (
        <div className="my-5">
          <Typography className="text-md text-primary text-center">
            {description}
          </Typography>
        </div>
      )}
      {children}
      <div className="flex justify-center space-x-5 mt-5">
        <OutlinedButtons
          id="close-information-dialog"
          color={CLOSE}
          onClick={() => onClose()}
          className="uppercase"
        >
          {formatMessage({ id: closeText })}
        </OutlinedButtons>
      </div>
    </CustomsSubmitDialog>
  )
}

InformationDialog.propTypes = {
  id: PropTypes.string,
  open: PropTypes.bool,
  title: PropTypes.string,
  onClose: PropTypes.func,
  children: PropTypes.node,
  className: PropTypes.string,
  description: PropTypes.string,
  closeText: PropTypes.string,
}
export default InformationDialog
